export const foremanRoute = {
  base: '/foreman',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const foremanRouteVehicles = {
  vehicles: `${foremanRoute.base}${foremanRoute.vehicles}`,
};

export const foremanRouteTrucks = {
  trucks: `${foremanRoute.base}${foremanRoute.vehicles}${foremanRoute.trucks}`,
};

export const foremanRouteEquipments = {
  equipments: `${foremanRoute.base}${foremanRoute.vehicles}${foremanRoute.equipments}`,
};

export const foremanRouteTrailers = {
  trailers: `${foremanRoute.base}${foremanRoute.vehicles}${foremanRoute.trailers}`,
};

export const foremanRouteVendors = {
  vendors: `${foremanRoute.base}${foremanRoute.vendors}`,
  detailVendor: `${foremanRoute.base}${foremanRoute.vendors}${foremanRoute.commonDetail}`,
};

export const foremanRoutePurchaseOrder = {
  purchaseOrder: `${foremanRoute.base}${foremanRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) =>
    `${foremanRoute.base}${foremanRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const foremanRouteOrder = {
  order: `${foremanRoute.base}${foremanRoute.order}`,
  detailOrder: (orderId: string) => `${foremanRoute.base}${foremanRoute.order}/${orderId}`,
  updateOrder: (orderId: string) => `${foremanRoute.base}${foremanRoute.order}/${orderId}${foremanRoute.commonEdit}`,
};

export const foremanRouteCrm = {
  crm: `${foremanRoute.base}${foremanRoute.crm}`,
  leads: `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.leads}`,
  createLead: `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.leads}${foremanRoute.commonCreate}`,
  detailLead: (leadId: string) => `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.leads}/${leadId}${foremanRoute.commonEdit}`,
  clients: `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.clients}`,
  createClient: `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.clients}${foremanRoute.commonCreate}`,
  detailClient: (clientId: string) => `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.clients}/${clientId}${foremanRoute.commonEdit}`,
};

export const foremanRouteQuote = {
  quotes: `${foremanRoute.base}${foremanRoute.quotes}`,
  createQuotes: `${foremanRoute.base}${foremanRoute.quotes}${foremanRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${foremanRoute.base}${foremanRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) => `${foremanRoute.base}${foremanRoute.quotes}/${quoteId}${foremanRoute.commonEdit}`,
};

export const foremanRouteInventory = {
  inventories: `${foremanRoute.base}${foremanRoute.inventory}`,
  inventory: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.product}`,
  createInventory: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.product}${foremanRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.product}/${inventoryId}${foremanRoute.commonEdit}`,
};

export const foremanRoutePackage = {
  package: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.package}`,
  createPackage: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.package}${foremanRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.package}/${packageId}${foremanRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.package}/${packageId}${foremanRoute.commonClone}`,
};

export const foremanRouteUser = {
  users: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.users}`,
  createUser: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.users}${foremanRoute.commonCreate}`,
  detailUser: (userId: string) => `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.users}/${userId}${foremanRoute.commonEdit}`,
};

export const foremanRouteVenue = {
  venue: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.venue}`,
  createVenue: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.venue}${foremanRoute.commonCreate}`,
  detailVenue: (venueId: string) => `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.venue}/${venueId}${foremanRoute.commonEdit}`,
};

export const foremanRouteInvoice = {
  invoices: `${foremanRoute.base}${foremanRoute.invoice}`,
  createInvoice: `${foremanRoute.base}${foremanRoute.invoice}${foremanRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) =>
    `${foremanRoute.base}${foremanRoute.invoice}/${invoiceId}${foremanRoute.commonEdit}`,
};

export const foremanRouteRoleManagement = {
  roleManagement: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.roleManagement}`,
  createRole: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.roleManagement}${foremanRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.roleManagement}/${roleId}${foremanRoute.commonEdit}`,
};

export const foremanRouteRoleCoupon = {
  coupon: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.coupon}`,
};

export const foremanRouteRoleEventType = {
  eventType: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.eventType}`,
};

export const foremanRouteRoleCategory = {
  category: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.category}`,
};

export const foremanRouteRoleChecklist = {
  checklist: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.checklist}`,
};

export const foremanRouteJob = {
  jobs: `${foremanRoute.base}${foremanRoute.jobs}`,
  detailJob: (jobId: string) => `${foremanRoute.base}${foremanRoute.jobs}/${jobId}`,
};

export const foremanRouteQuarantine = {
  quarantine: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.quarantines}`,
};

export const foremanRouteTask = {
  task: `${foremanRoute.base}${foremanRoute.task}`,
};

export const foremanRouteGlobal = {
  global: `${foremanRoute.base}${foremanRoute.global}`,
};

export const foremanRouteReport = {
  reports: `${foremanRoute.base}${foremanRoute.reports}`,
  overbookingItem: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.overbookingItem}`,
  subrentalsReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.subrentalsReport}`,
  clientIncomeReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.clientIncomeReport}`,
  revenueReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.revenueReport}`,
  geographicRevenueReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.quoteRevenueReport}`,
  orderRevenueReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.orderRevenueReport}`,
  cancellationReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.cancellationReport}`,
  deliveryReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.deliveryReport}`,
  taskCompletionReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.taskCompletionReport}`,
  discountUsageReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.discountUsageReport}`,
  featureUtilizationReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.featureUtilizationReport}`,
  jobCostingReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.jobCostingReport}`,
  inventoryUsageReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.inventoryUsageReport}`,
  quarantineReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.quarantineReport}`,
  foremanTaskReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.foremanTaskReport}`,
  marketingRevenueReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.marketingRevenueReport}`,
  financialOrderReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.financialOrderReport}`,
  transactionSummaryReport: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.transactionSummaryReport}`,
};

export const foremanRouteAbsolute = {
  // Dashboard
  dashboard: foremanRoute.base,

  // Communication
  communication: `${foremanRoute.base}${foremanRoute.communication}`,

  // Settings
  settings: `${foremanRoute.base}${foremanRoute.settings}`,

  // Schedule
  schedule: `${foremanRoute.base}${foremanRoute.schedule}`,

  ...foremanRouteVehicles,
  ...foremanRouteTrucks,
  ...foremanRouteEquipments,
  ...foremanRouteTrailers,
  ...foremanRouteVendors,
  ...foremanRoutePurchaseOrder,
  ...foremanRouteOrder,
  ...foremanRouteCrm,
  ...foremanRouteQuote,
  ...foremanRouteInventory,
  ...foremanRoutePackage,
  ...foremanRouteUser,
  ...foremanRouteVenue,
  ...foremanRouteRoleManagement,
  ...foremanRouteRoleCoupon,
  ...foremanRouteRoleEventType,
  ...foremanRouteRoleCategory,
  ...foremanRouteRoleChecklist,
  ...foremanRouteJob,
  ...foremanRouteQuarantine,
  ...foremanRouteInvoice,
  ...foremanRouteReport,
  ...foremanRouteTask,
  ...foremanRouteGlobal,
};
